module.exports = __webpack_public_path__ + "img/waves.10c32f43.svg";